export default class specManager {
    constructor() {

        this.$triggerStandard = document.querySelectorAll('.js__sort__btn[data-size="standard"]');
        this.$triggerMini = document.querySelectorAll('.js__sort__btn[data-size="mini"]');

        this.$dataStandard = document.querySelectorAll('.js__standard');
        this.$dataMini = document.querySelectorAll('.js__mini');

        this.$table = document.querySelectorAll('.p-spec-table');
        this.$photo = document.querySelectorAll('.p-spec-photo');

        this.$slide = document.querySelectorAll('.p-spec-slide>*');
        this.slideCount = 0;

        TweenMax.set(this.$slide[0], {
            display: 'block',
            opacity: 1
        })

    }

    init() {

        for (let i = 0; i < this.$triggerStandard.length; i++) {
            // standardを表示
            this.$triggerStandard[i].addEventListener("click", () => {
                this.change('ricepot');
            });
        }

        // miniを表示
        for (let i = 0; i < this.$triggerMini.length; i++) {
            // standardを表示
            this.$triggerMini[i].addEventListener("click", () => {
                this.change('mini');
            });
        }

        this.slide();

    }

    change(type){

        if(type === 'ricepot'){
            for (let i = 0; i < this.$triggerStandard.length; i++) {
                // カレント表示切り替え
                this.$triggerStandard[i].classList.add('is-selected');
                this.$triggerMini[i].classList.remove('is-selected');
            }
            // miniの情報を非表示
            for (let i = 0; i < this.$dataMini.length; i++) {
                this.$dataMini[i].classList.add('is-sp-hide');
            }
            // standardの情報を表示
            for (let i = 0; i < this.$dataStandard.length; i++) {
                this.$dataStandard[i].classList.remove('is-sp-hide');
            }
        }else{
            for (let i = 0; i < this.$triggerMini.length; i++) {
                // カレント表示切り替え
                this.$triggerMini[i].classList.add('is-selected');
                this.$triggerStandard[i].classList.remove('is-selected');
            }
            // standardの情報を非表示
            for (let i = 0; i < this.$dataStandard.length; i++) {
                this.$dataStandard[i].classList.add('is-sp-hide');
            }
            // miniの情報を表示
            for (let i = 0; i < this.$dataMini.length; i++) {
                this.$dataMini[i].classList.remove('is-sp-hide');
            }
        }

        // 表示アニメーション
        this.show();

    }

    show() {
        TweenMax.set([this.$photo, this.$table], {opacity: 0});
        TweenMax.to([this.$photo, this.$table], 0.3, {
            ease: Power3.easeIn,
            opacity: 1,
        });
    }

    slide(){

        TweenMax.to(this.$slide[this.slideCount], 0.9, {
            delay:3,
            display: 'none',
            opacity: 0,
            ease: Power2.easeOut,
            onStart: () =>{
                this.$slide[this.slideCount].classList.remove('is-active');
                if(this.slideCount === 1){
                    this.slideCount = 0;
                }else{
                    this.slideCount = 1;
                }
                this.$slide[this.slideCount].classList.add('is-active');
                TweenMax.to(this.$slide[this.slideCount], 0.6, {
                    display: 'block',
                    opacity: 1,
                    ease: Power2.easeIn,
                    onComplete:()=>{
                        this.slide();
                    }
                });
            }
        })

    }


}
